<template>
  <div class="Home">
    
    <div class="container-fluid pt-2" style="background-color:white">
      <div class="row">
      
        <div class="col-md-6 col-sm-12">
          <router-link to="/" style="text-decoration: none;" >
            <img src="@/assets/logo_itsapp.png" alt="" width="30%">
          </router-link>
        </div>
    
        <div class="col-md-6 col-sm-12">
          <nav class="pt-2">
            <ul class="nav justify-content-end" v-if="!sesion">
              <li class="nav-item pr-2">
                <router-link to="/registro" class="nav-link btn btn-sm btn-outline-primary">Registrarse</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/Login" class="btn orange">Entrar</router-link>
              </li>
            </ul>

            <div class="stars" v-if="sesion">
              <div class="row">
                <div class="col-md-7">
                  <small v-if="rol==0" class="float-right"><b>Membresia:</b> {{membresia}}</small> <br>
                  <small v-if="rol==0" class="float-right" ><b>Vence:</b> {{fechaFormat(fecha)}}</small>
                </div>
                <div  class="col-md-4">
                  <p><star-rating :increment="0.1" :rating="makeNumber(estrellas)" :star-size="20" 
                  :show-rating="false" :read-only="true"/></p>
                </div>
                <div class="col-md-1">
                  <button class="btn orange mt-2 float-right" @click="close">Salir</button>
                </div>
              </div>
            </div>

          </nav>
        </div>

      </div>
    </div>

  </div>
</template>


<script>
import StarRating from 'vue-star-rating';
import { globalFunctions } from '@/hooks/globalFunctions'
export default {
name: 'Menu',
mixins: [ globalFunctions ],
components:{ StarRating },
props:['sesion'],
data () {
  return {
    cerrar_sesion: false,
    UserName : localStorage.userID,
    membresia: '',
    fecha: '',
    estrellas: '',
    rol: localStorage.rol,
  }
},
methods: {
  close(){
      let data = {
        id: this.UserName
      }
      
      this.axios.post(this.url + "cerrarSesion.php", data).then((responce) => {
        if(responce.data== 200){
          localStorage.token = null;
          this.$router.push('/');
        }
      });
  },
  getData(){
    let data = {
          rol: localStorage.rol,
          id: this.UserName
        }

    //obtenemos los datos del usuario ya sea empresa o consultor
    this.axios.post(this.url + 'consultar.php', data).then((responce) =>{
        this.name = responce.data[0].usuario;
        this.fecha = responce.data[0].fecha_fin;
        this.estrellas = responce.data[0].estrellas;

        let tipoMembresia = responce.data[0].t_user
        
        switch (tipoMembresia) {
          case '0':
            if(this.rol == '0'){
              this.membresia = 'Gratis'
            }else{
              this.membresia = 'Empresarial'
            }
            break;
          case '1':
            this.membresia = 'Mensual'
            break;
          case '2':
            this.membresia = 'Semestral'
            break;
          case '3':
            this.membresia = 'Anual'
            break;
        }
    });

  }
},
mounted(){
  this.rol = localStorage.rol;
  this.getData();
}
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

.stars{
 display: none; 
}

}

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue